<template>
  <div style="background-color:rgba(0, 0, 0, 0.1);width:100vw;height:100vh;">
    <div class="bgi" :style="logoBgi">
      <div class="images" style="display:flex;">
        <!-- <img src="https://file.sciseetech.com/file/images/logo1.png" alt="" class="image1"> -->
        <div>停车云</div>
        <div class="imageDiv"></div>
        <div>运营管理系统</div>
        <!-- <img src="../../assets/images/logo_02.png" alt="" class="image2"> -->
      </div>
      <div class="login-container">
        <el-form class="login-form" auto-complete="on" label-position="left">
          <div class="login-tab">
            <div :class="loginType == 1 ? 'login-title-tab' : 'login-title-tab1'" @click="getWechatUrl('1')">账号登录</div>
            <div class="login-title-line"></div>
            <div :class="loginType == 2 ? 'login-title-tab' : 'login-title-tab1'" @click="getWechatUrl('2')">微信登录</div>
          </div>
          <el-form-item prop="username" v-show="loginType == '1'">
            <el-input v-model="username" placeholder="请输入用户名" prefix-icon="el-icon-user-solid" maxlength="50" v-trim/>
          </el-form-item>
          <el-form-item prop="password" v-show="loginType == '1'">
            <el-input v-model="password" placeholder="请输入密码" type="password" prefix-icon="yunying-icon-password" maxlength="30" show-password/>
          </el-form-item>
          <div class="captcha-input" v-show="loginType == '1'">
            <el-input v-model="captcha.value" placeholder="图片验证码" prefix-icon="yunying-icon-shield" maxlength="4" @keypress.enter.native="login"/>
            <img v-if="!captcha.loading" :src="captcha.uri" @click="refreshCaptcha">
            <span v-else><i class="el-icon-loading"></i></span>
          </div>
          <!-- 微信扫码登录 -->
          <div class="info-input" v-show="loginType == '2'">
            <div id="qrcode" ></div>
          </div>
          <el-button :loading="loading" @click="login" v-show="loginType == '1'">登&nbsp;&nbsp;录</el-button>
          <!-- <div class="login-type" style="margin-bottom:20px;text-align:center;">
            <el-radio-group v-model="loginType" @change="getWechatUrl">
              <el-radio label="1">账号登录</el-radio>
              <el-radio label="2">微信扫码登录</el-radio>
            </el-radio-group>
            
          </div> -->


          <!-- <el-button
            v-show="loginType == '1'"
            :loading="loading"
            type="primary"
            style="width:100%;margin-bottom:30px;"
            @click.native.prevent="login">登录</el-button> -->
        </el-form>
      </div>
    </div>
    <div class="main-footer" style="position:fixed;bottom:6px;left: 40%;">
          <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right:20px;color:#fff;">蜀ICP备16034694号</a>  
          <!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51019002002030" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../../assets/images/icpimg.png" style="float:left;">
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;">川公网安备 51019002002030号</p>
          </a> -->
        </div>
  </div>
  <!-- <div class="wrap">
    <div class="introduce">
      <h2>停车场运管系统</h2>
    </div>
    <div class="login">
      <h1>登录</h1>
      <div class="info-input" v-show="loginType == '1'">
        <el-input v-model="username" placeholder="请输入用户名" prefix-icon="el-icon-user-solid" maxlength="50" v-trim/>
        <el-input v-model="password" placeholder="请输入密码" type="password" prefix-icon="yunying-icon-password" maxlength="30" show-password/>
        <div class="captcha-input">
          <el-input v-model="captcha.value" placeholder="图片验证码" prefix-icon="yunying-icon-shield" maxlength="4" @keypress.enter.native="login"/>
          <img v-if="!captcha.loading" :src="captcha.uri" @click="refreshCaptcha">
          <span v-else><i class="el-icon-loading"></i></span>
        </div>
      </div>
      
      
      


    
      <div class="info-input" v-show="loginType == '2'">
        <div id="qrcode" ></div>
      </div>

      <div class="login-type" style="margin-bottom:20px;">
        <el-radio-group v-model="loginType" @change="getWechatUrl">
          <el-radio label="1">账号登录</el-radio>
          <el-radio label="2">微信扫码登录</el-radio>
        </el-radio-group>
        
      </div>
      <el-button :loading="loading" @click="login">登&nbsp;&nbsp;录</el-button>
    </div>


    
  </div> -->
</template>

<script>
import { mapMutations } from 'vuex'
import { getCaptcha, loginByPassword ,getWxScanUrl ,getWxLoginResult } from '@/api/system/common'
import { setToken } from "@/utils/auth"; // get token from cookie
import QRCode from 'qrcodejs2'
import CryptoJS from "crypto-js";
let key = CryptoJS.enc.Utf8.parse("istyunying202203");
let iv = CryptoJS.enc.Utf8.parse("istyunying202203");
export default {
  name: 'Login',
  data () {
    return {
      logoBgi:{ 
        // backgroundImage:"url("+require("../../assets/images/logo_bgi.jpg")+")",
        backgroundSize:' 100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(https://file.sciseetech.com/file/images/logoBg.png)"
      },
      loginType:'1',
      loading: false,
      username: '',
      password: '',
      // 验证码
      captcha: {
        loading: false,
        value: '',
        uuid: '',
        uri: ''
      },
      queryStatus:null,
    }
  },
  destroyed(){
    let that = this;
    if(this.queryStatus != null){
      clearInterval(that.queryStatus)
      that.queryStatus = null;
    }
  },
  methods: {
    ...mapMutations(['setUserInfo']),
    // 获取微信二维码
    getWechatUrl(value){
      let that = this;
      this.loginType = value
      if(document.getElementById("qrcode")){
        document.getElementById("qrcode").innerHTML = "";
      }
      if(this.loginType == '2'){
        getWxScanUrl({type:0}).then(res=>{
          that.$nextTick(function () {
            document.getElementById("qrcode").innerHTML = "";
            let qrcode = new QRCode("qrcode", {
              width: 150,
              height: 150,
              text:res,
            });
          });
          var arr = res.split("=")
          that.queryStatus = setInterval(function () {
            that.getWxLoginResult(arr[1]);
          },1000);
        })
      }else{
        if(document.getElementById("qrcode")){
          document.getElementById("qrcode").innerHTML = "";
        }
        if(this.queryStatus != null){
          clearInterval(that.queryStatus)
          that.queryStatus = null;
        }
      }
      
    },
    getWxLoginResult(state){
      var that = this
      var param = {
        'state':state,
      }
      getWxLoginResult(param).then(response => {
        var data = response
        console.log(data)
        if(data){
          clearInterval(that.queryStatus)
          that.queryStatus = null;
          setToken(data.token)
          if(data.identity == 'admin'){
            sessionStorage.setItem('isAdmin',true);
          }else{
            sessionStorage.setItem('isAdmin',false);
          }
          this.$nextTick(() => {
            this.$router.push('/index')
          })
          this.$nextTick(() => {
            this.$router.push('/index')
          })
          this.$message({
            message: '登录成功',
            type: 'success',
            duration: 2 * 1000
          })

        }else {
          clearInterval(that.queryStatus)
          that.queryStatus = null;
          this.$message({
            message: data.msg,
            type: 'error',
            duration: 2 * 1000
          })
        }
      }).catch(e=>{
        if(e.code == 4006){
          clearInterval(that.queryStatus)
          this.$message({
            message: '该微信未绑定账号',
            type: 'error',
            duration: 2 * 1000
          })
        }
      })
    },
    // 登录
    login () {
      if (this.loading) {
        return
      }
      if (!this.__check()) {
        return
      }
      // 密码加密
      let pwd = CryptoJS.AES.encrypt(this.password.trim(), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC
      }).toString();
      this.loading = true
      loginByPassword({
        username: this.username.trim(),
        password: pwd,
        code: this.captcha.value.trim(),
        uuid: this.captcha.uuid
      })
        .then((res) => {
          setToken(res.token)
          if(res.identity == 'admin'){
            sessionStorage.setItem('isAdmin',true);
          }else{
            sessionStorage.setItem('isAdmin',false);
          }
          this.$nextTick(() => {
            this.$router.push('/index')
          })
        })
        .catch(e => {
          this.refreshCaptcha()
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 刷新验证码
    refreshCaptcha () {
      this.captcha.loading = true
      getCaptcha()
        .then(data => {
          this.captcha.uri = data.image
          this.captcha.uuid = data.uuid
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          setTimeout(() => {
            this.captcha.loading = false
          }, 150)
        })
    },
    // 登录前验证
    __check () {
      if (this.username.trim() === '') {
        this.$tip.error('请输入用户名')
        return false
      }
      if (this.password === '') {
        this.$tip.error('请输入密码')
        return false
      }
      if (this.captcha.value.trim() === '') {
        this.$tip.error('请输入图片验证码')
        return false
      }
      return true
    }
  },
  created () {
    this.refreshCaptcha()
  }
}
</script>

<style scoped lang="scss">
$bg: #2d3a4b;
$dark_gray: #51596D;
$light_gray: #707070;
$bg: #283443;
$light_gray: #fff;
$cursor: #fff;
.bgi{
  width: 100%;
  height: 100vh;
  background-color:$bg;
  display: flex;
  justify-content: space-around;
}
.login-container {
  .svg-container {
    padding: 0px 5px 6px 15px;
    color: $dark_gray;
    width: 30px;
    display: inline-block;
    height: 36px;
  }
  /deep/ .el-input__inner {
      background: transparent !important;
      border: 0;
      -webkit-appearance: none;
      border-radius: 0px;
      // padding: 12px 5px 12px 12px;
      color: $light_gray;
      height: 40px;
      // margin-left: 5px;
      caret-color: #000;

      // &:-webkit-autofill {
      //   box-shadow: 0 0 0px 1000px #0D1A50 inset !important;
      //   -webkit-text-fill-color: $cursor !important;
      // }
    }
  //  /deep/ .el-input {
  //   display: inline-block;
  //   height: 42px;
  //   width: 88.3%;
  //   margin-left: 6px;

    
    
  // }
  
   /deep/ .el-form-item{
    background: #E8F0FD;
    border-radius: 5px;
    color: #454545;
    border:1px solid #CED1D9;
  }
  /deep/ .el-input__inner{
    background: #E8F0FD;
    border-radius: 5px;
    color: #454545;
    // border:1px solid #CED1D9;
  }
  max-height: 100%;
  overflow: hidden;

  .login-form {
    position: absolute;
    width: 300px;
    min-height: 460px;
    max-width: 100%;
    background-color: #FFFFFF;
    padding: 20px;
    border-radius:5px;
    top:30%;
    right:15%;
    min-height: 300px;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;
    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }
.el-form-item__content{
  line-height: 25px !important;
}
  .svg-container {
    padding: 0px 5px 6px 15px;
    color: $dark_gray;
    width: 30px;
    display: inline-block;
    height: 36px;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 20px;
      color: $light_gray;
      margin: 0px auto 30px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.login-tab{
  display: flex;
  width: 302px;
  height: 40px;
  line-height: 40px;
  font-family: SFNSDisplay;
  font-size: 16px;
  color: #292929;
  margin: 20px auto;
  background: #3c75cf;
  border-radius: 10px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
}
.login-title-tab{
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #fff;
  text-align: center;
  
}
.login-title-line{
  width: 1px;
  height: 52px;
  background: #fff;
}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
.login-title-tab1{
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #fff;
  text-align: center;
  // border-radius: 0 10px 10px 0;
  background: #66b1ff;
}
.images{
  position: absolute;
  top:40%;
  left:10%;
  color:#ffffff;
  font-weight: bolder;
  color: #ffffff;
  font-weight: bold;
  font-size: 32px;
  letter-spacing: 4px;
  line-height: 40px;
}
.images>div{
  font-size: 32px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.imageDiv{ 
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin: 0 16px;
  width: 2px;
  height: 40px;
  background: #fff;
}
.image1{
  vertical-align: middle;
  width:40px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
.image2{
  vertical-align: middle;
  width: 180px;
}
@import "@/assets/style/variables.scss";
$input-gap: 30px;
.wrap {
  display: flex;
  width: 100%;
  height: 100vh;
  background-image: url("../assets/images/login.jpg");
  background-repeat: no-repeat;
  background-size: auto 180%;
  background-clip: content-box;
  background-position: center;
  // 左边介绍
  .introduce {
    padding-left: 10%;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    h2 {
      font-size:34px;
      // font-style: italic;
      font-weight: 900;
      margin-top: 50px;
    }
    h3 {
      font-size: 49px;
      font-weight: 300;
      margin: 25px 0;
    }
  }
  // 右边登录
  .login {
    height: 100%;
    width: 30%;
    max-width: 560px;
    
    flex-shrink: 0;
    text-align: center;
    background: #fff;
    padding: 0 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    h1 {
      font-size: 28px;
      font-weight: 500;
    }
    .info-input {
      margin-top: $input-gap;
      margin-bottom: 60px;
      /deep/ .el-input {
        margin-top: 30px;
        .el-input__inner {
          height: 50px;
          background: #F9F9F9;
          border: 1px solid transparent;
          &:focus {
            border: 1px solid $primary-color;
          }
        }
      }
    }
    

  }
}
 #qrcode{
   width: 150px;
   margin: 0 auto;
 }
 // 验证码输入
    .captcha-input {
      display: flex;
      margin-top: $input-gap;
      height: 50px;
      /deep/ .el-input__inner {
        width: 100%;
        margin-top: 0;
        height: 50px !important;
        background: #f9f9f9 !important;
      }
      span, img {
        width: 45%;
        height: 100%;
        flex-shrink: 0;
        margin-left: 16px;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
        border-radius: 8px;
      }
    }
    .el-button {
      height: 40px;
      width: 100%;
      color: #fff;
      font-size: 16px;
      margin-top: 20px;
      background: linear-gradient(130deg, $primary-color + 20 0%, $primary-color - 20 100%);
    }

     @media screen and (max-width:600px){
      .login {
        width:100% !important;
      }
      .introduce {
        display: none !important;
      }
    }
</style>
